<template>
    <div class="xxdata">
        <vx-card title="">
            <div class="search-main">
                <el-input v-model="keyWords" size="medium" placeholder="请输入手机号" style="width: 200px;"></el-input>
                <el-button style="margin-left: 15px" size="medium" @click="handleSearch" icon="el-icon-search" type="primary">查询</el-button>
                <el-button style="margin-left: 15px" size="medium" @click="handleReset" icon="el-icon-refresh" type="info">重置</el-button>
            </div>
        <el-table :data="list" border style="width: 100%;margin-top: 15px">
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column  label="姓名" prop="realname"></el-table-column>
            <el-table-column  label="手机号" prop="username"></el-table-column>
            <el-table-column  label="仓库权限" prop="ws_names"></el-table-column>
            <el-table-column  label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="editStaff(scope.row.id)">仓库权限配置</el-button>
                </template>
            </el-table-column>
        </el-table>
<!--            <role-warehouse-list-table />-->
            <div style="margin: 20px 0 0 0; text-align: center">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="current"
                        :page-size="size"
                        layout="total, sizes , prev, pager, next , jumper"
                        :total="total"
                >
                </el-pagination>
            </div>

        </vx-card>
    </div>
</template>

<script>
    import {Mod_Role_Warehouse} from "../../server-api/RoleWarehouse";
    import {Navigator} from "@/router/Navigator";
export default {
    data () {
        return {
            keyWords:null,
            list: [],
            current:1,
            size:10,
            total:null,
            state:'',
        }
    },
    computed: {
    },
    methods: {
         handleReset(){
             this.keyWords = null;
             this.current = 1;
             this.size = 10;
             this.getList();

        },
        handleSearch(){
            this.current = 1;
            this.size = 10;
            this.getList();
        },
        handleSizeChange(val){
            this.size = val;
            this.getList();
        },
        handleCurrentChange(val){
            this.current = val;
            this.getList();
        },
        editStaff(id){
            console.log(id)
            let path = `/modules/role_warehouse/edit/${id}`;
            Navigator.redirect(path);
        },
        async getList(){
            let params = {
                size: this.size,
                current:this.current,
                data:{
                    username:this.keyWords
                }
            }
            let resp = await Mod_Role_Warehouse.getMemberList(params);
            this.list = resp.records;
            this.total = resp.total;
            console.log(resp);
        }
    },
    created() {
        this.getList();
    }
}
</script>
